import request from "#/utils/request";
const api = "/api";
const h5api = "/h5-api";

//

export function createOrder(data) {
  return request({
    url: h5api + "/v1/cash/charge/create",
    method: "post",
    data,
  });
}
//

export function verifyReceipt(data) {
  return request({
    url: h5api + "/v1/cash/charge/verify_receipt",
    method: "post",
    data,
  });
}

//
export function getChargeProducts(rechargeUid) {
  return request({
    url: h5api + "/v1/cash/charge/product",
    method: "post",
    rechargeUid,
  });
}

export function getUser(data) {
  return request({
    url: h5api + "/v1/cash/user/check",
    method: "post",
    data,
  });
}

export function getChargeProductIten(pid, payItemType, rechargeUid) {
  return request({
    url: `${h5api}/v1/cash/charge/product/${pid}`,
    method: "get",
    rechargeUid,
    params: {
      payItemType
    }
  });
}
